<template>
  <div>
    <comHeader
      :active="12"
      :value="value"
      style="background-color: rgba(156, 187, 107, 1); border: none"
    >
      <template #dovlogo>
        <img src="@/assets/doc/img/logoleft.png" alt="" @click="hidelist" />
      </template>
    </comHeader>
    <button
      class="tooltip"
      v-show="selectedText"
      ref="button"
      @click="copySelectedText"
      style="
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        background: none;
      "
    >
      <img
        src="@/assets/doc/img/提问.png"
        style="width: 35px; height: 35px"
        alt=""
      />
      <span class="tooltiptext">提问</span>
    </button>
    <div class="center" v-loading="loading">
      <div class="center_left" id="center_left">
        <div class="center_left_top" @click="pdf_url = ''">
          <img
            src="@/assets/img/huihua_.png"
            style="width: 25px; height: 25px"
            alt=""
          />
          <p class="center_left_top_title">ChatData</p>
          <p class="center_left_top_titles">深度数据智能分析工具</p>
        </div>
        <div class="create_ask">
          <div
            style="height: 100%"
            :class="typeactive == 2 ? 'typeactive' : ''"
            @click="filetabs(2)"
          >
            文献列表
          </div>
          <div
            style="height: 100%"
            :class="typeactive == 1 ? 'typeactive' : ''"
            @click="filetabs(1)"
          >
            会话列表
          </div>
        </div>
        <!-- <div class="create_ask_btn" @click="createAsk" v-if="typeactive == 1">
          创建会话
        </div> -->
        <div
          class="create_ask_btn_no"
          @click="createAsk"
          v-if="typeactive == 1"
        >
          创建会话（暂未开通）
        </div>

        <div class="center_left_topbtn" v-if="typeactive == 2">
          <el-upload
            class="upload-demo"
            ref="upload"
            style="width: 100%"
            multiple
            action="https://jsonplaceholder.typicode.com/posts/"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handlePreview"
            :http-request="customUploadMethod"
            :limit="10"
            drag
            :file-list="fileList"
            accept=".xls,.xlsx"
          >
            <div class="uploaddiv">
              <svg
                t="1685601437969"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="25670"
                width="32"
                height="32"
              >
                <path
                  d="M120.892235 421.285647h223.472941v361.050353h335.269648V421.285647h223.472941L512 0 120.892235 421.285647z m0 481.400471v120.350117h782.21553v-120.350117H120.892235z"
                  fill="#333333"
                  p-id="25671"
                ></path>
              </svg>
              <p>文件上传</p>
              <p><span>拖入文件或点击上传</span></p>
            </div>
          </el-upload>
        </div>
        <ul class="asklist" v-if="typeactive == 1">
          <li v-for="(item, index) in userList" :key="index">
            <div
              :class="
                uesrpdfindex == index
                  ? 'asklist_ask asklist_askactive'
                  : 'asklist_ask'
              "
              @click="getgroup_pdf(item.group_id, index)"
            >
              <div>
                <i class="el-icon-folder-opened"></i>{{ item.group_name }}
              </div>
              <div>
                <i
                  class="el-icon-delete-solid"
                  @click.stop="delask(item.group_id)"
                ></i
                ><img
                  src="@/assets/doc/img/编辑 (1).png"
                  alt=""
                  @click.stop="edit(item)"
                /><i
                  class="el-icon-arrow-down"
                  v-show="uesrpdfindex != index"
                ></i
                ><i class="el-icon-arrow-up" v-show="uesrpdfindex == index"></i>
              </div>
            </div>
            <ul class="filelist">
              <li
                v-show="uesrpdfindex == index"
                :class="indexs_file == indexpdf ? 'active' : ''"
                v-for="(itempdf, indexpdf) in uesrpdflist"
                :key="indexpdf"
                @click="tabclick(indexpdf, '2')"
              >
                <div class="litop">
                  <img
                    v-if="itempdf.file_type == 0"
                    src="@/assets/doc/img/pdf.png"
                    alt=""
                  />
                  <img
                    v-if="itempdf.file_type == 1"
                    src="@/assets/doc/img/xls.png"
                    alt=""
                  />
                  <p>{{ itempdf.pdf_name }}</p>
                  <i
                    class="el-icon-error"
                    style="color: #c7c7c7"
                    @click.stop="delpdf(indexpdf, itempdf)"
                  ></i>
                </div>
                <div class="libottom">
                  <div>
                    <i class="el-icon-time"></i>{{ itempdf.create_time }}
                  </div>
                  <div>
                    <i
                      v-if="itempdf.pdf_state == 1"
                      class="el-icon-check"
                      style="color: green"
                    ></i
                    ><i
                      v-if="itempdf.pdf_state == 0"
                      class="el-icon-loading"
                      style="color: blue"
                    ></i
                    ><i
                      v-if="itempdf.pdf_state == -1"
                      class="el-icon-close"
                      style="color: red"
                    ></i>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <!-- <div
          v-if="typeactive == 2 && (leftList || defaultList)"
          class="filetab"
        >
          <el-radio-group v-model="leftListShow" @input="filetab">
            <el-radio :label="0">pdf</el-radio>
            <el-radio :label="1">excel</el-radio>
          </el-radio-group>
        </div> -->
        <ul class="filelist" v-if="typeactive == 2">
          <li
            :class="indexs == index ? 'active' : ''"
            v-for="(item, index) in leftList"
            :key="index"
            @click="tabclick(index, '1')"
          >
            <div class="litop">
              <img
                v-if="item.file_type == 0"
                src="@/assets/doc/img/pdf.png"
                alt=""
              />
              <img
                v-if="item.file_type == 1"
                src="@/assets/doc/img/xls.png"
                alt=""
              />
              <!-- 双击文件名修改文件名 -->
              <p
                title="双击编辑文件名称"
                v-show="item.isedit == 1"
                @dblclick.stop="openinput(index)"
                @click.stop=""
              >
                {{ item.pdf_name }}
              </p>
              <input
                v-show="item.isedit == 2"
                :ref="'dbinput' + index"
                type="text"
                style="padding: 5px"
                v-model="item.pdf_name"
                @click.stop=""
                @blur="editname(item, index)"
              />
              <i
                v-if="item.isedit == 1"
                class="el-icon-error"
                style="color: #c7c7c7; font-size: 18px"
                @click.stop="delpdfs(index, item)"
              ></i>
            </div>
            <div class="libottom">
              <div style="margin-left: 10px">
                <i class="el-icon-time"></i>{{ item.create_time }}
              </div>
              <div>
                <i
                  v-if="item.pdf_state == 1"
                  class="el-icon-check"
                  style="color: green"
                ></i
                ><i
                  v-if="item.pdf_state == 0"
                  class="el-icon-loading"
                  style="color: blue"
                ></i
                ><i
                  v-if="item.pdf_state == -1"
                  class="el-icon-close"
                  style="color: red"
                ></i>
              </div>
            </div>
          </li>
          <li
            :class="indexsDe == index ? 'active' : ''"
            v-for="(item, index) in defaultList"
            :key="index + 'de'"
            @click="tabclick(index, '3')"
            v-show="item.file_type == leftListShow"
          >
            <div class="litop">
              <img
                v-if="item.file_type == 0"
                src="@/assets/doc/img/pdf.png"
                alt=""
              />
              <img
                v-if="item.file_type == 1"
                src="@/assets/doc/img/xls.png"
                alt=""
              />
              <!-- 双击文件名修改文件名 -->
              <p>{{ item.pdf_name }}</p>
            </div>
            <div class="libottom">
              <div style="margin-left: 10px">
                <i class="el-icon-time"></i>{{ item.create_time }}
              </div>
              <div style="margin-top: 10px">示例</div>
            </div>
          </li>
        </ul>

        <!-- <div class="center_left_fixed"  @click="hidelist">
            <img v-show="isshow == 'left'" src="@/assets/doc/img/arrow-right-filling.png" alt="">
            <img v-show="isshow == 'right'" src="@/assets/doc/img/arrow-left-filling.png" alt="">
          </div> -->
      </div>
      <div class="box1" v-show="pdf_url != ''">
        <div class="left">
          <div
            class="table"
            v-html="markdownToHtml"
            v-show="nowfiletype == 1"
          ></div>
          <iframe
            ref="iframe"
            id="iframe"
            v-show="nowfiletype == 0"
            @mousemove="dragControllerDiv"
            style="width: 100%; height: 100%"
            :src="'../../pdf/web/viewer.html?file=' + pdf_url"
            frameborder="0"
          ></iframe>
          <!-- <canvas  id="pdf-canvas"></canvas> -->
          <div class="mengcen"></div>
        </div>
        <div class="resize" title="收缩侧边栏" v-show="drawer"></div>
        <div class="mid" ref="mid" id="mid">
          <!-- 默认问题 -->
          <div class="default_question_box" id="default_question_box">
            <div class="top_fun_list" @click="showquestion">
              <div>
                <img
                  style="width: 25px; margin: 0 5px 0 8px; vertical-align: sub"
                  src="@/assets/doc/img/light.png"
                />
                <span style="font-size: 16px">快捷访问</span>
              </div>
              <div>
                <i class="el-icon-arrow-right" v-if="!questionshow"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </div>
            </div>
            <div class="default_question" v-if="questionshow">
              <div
                class="default_question_item"
                v-for="(item, index) in defaultQuestion"
                :key="index"
                @click="default_question_click(item)"
              >
                <span>{{ item }}</span>
              </div>
            </div>
          </div>

          <!-- <div class="mid_top"><img src="@/assets/doc/img/copilot-line.png"/> Copilot</div> -->
          <!-- 类似于chatpdf对话框 -->
          <div
            ref="box"
            id="div"
            class="message_s box"
            :style="'height:' + message_sheight"
          >
            <div v-for="(item, index) in list" :key="index" style="width: 100%">
              <div v-if="item.ask" class="ask_css">
                <div class="ask_img">
                  <img src="@/assets/doc/img/user.png" alt="" />
                </div>
                <div style="text-align: left">
                  <span
                    style="
                      text-align: justify;
                      display: inline-block;
                      line-height: 25px;
                    "
                  >
                    <span v-if="item.answer.includes('服务繁忙，请重试')">
                      <i
                        style="color: red; cursor: pointer"
                        class="el-icon-warning"
                        @click="shortcut(item.ask)"
                      ></i>
                    </span>
                    <span class="font_duan" v-show="item.ask_duan">
                      <span v-show="item.isimg == false">{{
                        item.ask_duan
                      }}</span>
                      <img
                        style="width: 100%"
                        v-show="item.isimg == true"
                        :src="item.ask_duan"
                        alt=""
                      />
                    </span>

                    <span style="font-weight: 600">{{ item.ask }}</span>
                  </span>

                  <br />
                  <span class="time__ask" style="">{{ item.ask_time }} </span>
                </div>
              </div>
              <div
                v-if="item.answer"
                class="answer_css"
                style="text-align: left; white-space: pre-wrap; width: 100%"
              >
                <div class="ask_img">
                  <img
                    style="width: 25px"
                    src="@/assets/doc/img/提问.png"
                    alt=""
                  />
                </div>
                <div style="width: 100%">
                  <div
                    style="display: flex; word-break: break-word; width: 100%"
                  >
                    <!-- <img width="50px" height="50px" style="border-radius: 25px;margin: 0 10px 0px 0;"
                      :src="log_img ? log_img : log_img_"/> -->
                    <div style="position: relative; width: 100%">
                      <!-- <div class="answer_css_" v-if="item.answer == '正在给您总结答案，请稍后...'" :data-text="item.answer">
                          {{ item.answer }}
                        </div> -->
                      <div class="answer_css_">
                        <span v-if="item.answer.includes('服务繁忙，请重试')"
                          >服务繁忙，请重试</span
                        >
                        <span v-else v-html="item.answer"></span>
                        <span
                          v-if="showBlinkCursor && index + 1 == list.length"
                          class="blinkCursor"
                          >_</span
                        >
                      </div>
                      <div
                        v-if="item.stat !== ''"
                        :class="
                          item.answer.length > 15 ? 'pointer_s' : 'pointer_s_'
                        "
                      >
                        <img
                          src="@/assets/doc/img/page.png"
                          alt=""
                          v-if="item.numbers"
                        />
                        <span
                          v-for="(items, indexs) in item.numbers"
                          :key="indexs"
                          @click="topage(items)"
                          >{{ items }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- <br /> -->
                  <span v-if="item.answer_time" class="time__answer" style="">{{
                    item.answer_time
                  }}</span>
                </div>
              </div>
              <div
                v-if="item.answer && item.stop_show"
                @click="stopask"
                class="stopask"
              >
                <img
                  src="@/assets/doc/img/stopask.png"
                  alt=""
                  style="width: 20px; margin-right: 5px"
                />
                停止回答
              </div>
            </div>
          </div>
          <div class="message_bottom" id="message_bottom">
            <div class="paragraphRe" v-show="paragraph || annex_img">
              <i class="el-icon-error" @click="removeparagraph"></i>
            </div>
            <div class="excel" v-show="annex_img">
              <img style="width: 100%" :src="annex_img" alt="" />
            </div>
            <textarea
              ref="input"
              v-show="paragraph"
              class="chat-input other"
              rows="1"
              v-model="paragraph"
            >
                <i class="el-icon-circle-close"></i>
              </textarea
            >

            <div class="chat-input">
              <div style="width: 100%">
                <el-checkbox
                  v-if="typeactive == 1"
                  v-model="checked"
                  title="仅对当前文章提问"
                ></el-checkbox>
                <input
                  type="text"
                  v-model="newMessage"
                  @keyup.enter="sendMessage"
                  placeholder="Type a message..."
                />
                <!-- <button @click="sendMessage">Send</button> -->
                <img
                  @click="sendMessage"
                  src="@/assets/doc/img/send.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- <div class="search-container">
                    <input type="text" class="search-input" placeholder="输入关键词">
                    <button class="search-button">
                      <i class="fas fa-search"></i>
                    </button>
                  </div> -->
        </div>
      </div>
      <div class="box1" v-show="pdf_url == ''">
        <div class="box_center">
          <div class="tagdiv">
            <div class="tagdiv_left">
              <h1>ChatData</h1>
              <img src="@/assets/img/huihua_.png" alt="" />
            </div>
            <div class="tagdiv_right">
              <h2>智能解析和深度分析，为您揭示数据中的见解。</h2>
              <p>
                ChatData通过对表格及数据集的智能解析，可以实现与表格进行对话式的提问。并且通过深度分析可自动生成可视化图表，让数据一目了然！
              </p>
            </div>
          </div>
          <div class="center_left_topbtn" style="width: 50%">
            <el-upload
              class="upload-demo"
              ref="upload"
              style="width: 100%"
              multiple
              action="https://jsonplaceholder.typicode.com/posts/"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handlePreview"
              :http-request="customUploadMethod"
              :limit="10"
              drag
              :file-list="fileList"
              accept=".xls,.xlsx"
            >
              <div class="uploaddiv">
                <svg
                  t="1685601437969"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="25670"
                  width="32"
                  height="32"
                >
                  <path
                    d="M120.892235 421.285647h223.472941v361.050353h335.269648V421.285647h223.472941L512 0 120.892235 421.285647z m0 481.400471v120.350117h782.21553v-120.350117H120.892235z"
                    fill="#333333"
                    p-id="25671"
                  ></path>
                </svg>
                <p>文件上传</p>
                <p><span>拖入文件或点击上传</span></p>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="创建会话"
      :visible.sync="dialogVisible1"
      width="30%"
      :before-close="handleClose"
    >
      <el-form ref="post" label-width="100px" style="overflow: hidden">
        <el-form-item label="会话名称" prop="username">
          <el-input v-model="groupname"></el-input>
        </el-form-item>
        <el-form-item label="当前已选择" style="text-align: left">
          {{ checkedCities.length }} 篇
        </el-form-item>
        <el-form-item label="文件选择" prop="username">
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
            style="
              display: flex;
              flex-direction: column;
              max-height: 40vh;
              overflow-x: hidden;
              overflow-y: auto;
            "
          >
            <el-checkbox
              v-for="city in cities"
              :key="city.pdf_id"
              :label="city.pdf_id"
              :disabled="city.file_type == 1"
              ><img
                style="width: 20px; margin-top: 5px; margin-right: 5px"
                v-if="city.file_type == 0"
                src="@/assets/doc/img/pdf.png"
                alt=""
              />
              <img
                style="width: 20px; margin-top: 5px; margin-right: 5px"
                v-if="city.file_type == 1"
                src="@/assets/doc/img/xls.png"
                alt=""
              />{{ city.pdf_name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label-width="0px">
          <el-button type="primary" @click="createSession('1')">创建</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="编辑会话"
      :visible.sync="dialogVisible2"
      width="30%"
      :before-close="handleClose"
    >
      <el-form ref="post" label-width="100px">
        <el-form-item label="会话名称">
          <el-input v-model="groupname"></el-input>
        </el-form-item>
        <el-form-item label="当前已选择" style="text-align: left">
          {{ checkedCities.length }} 篇
        </el-form-item>
        <el-form-item label="文件选择">
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
            style="
              display: flex;
              flex-direction: column;
              max-height: 40vh;
              overflow-x: hidden;
              overflow-y: auto;
            "
          >
            <el-checkbox
              v-for="city in cities"
              :label="city.pdf_id"
              :key="city.pdf_id"
              :disabled="city.file_type == 1"
            >
              <img
                style="width: 20px; margin-top: 5px; margin-right: 5px"
                v-if="city.file_type == 0"
                src="@/assets/doc/img/pdf.png"
                alt=""
              />
              <img
                style="width: 20px; margin-top: 5px; margin-right: 5px"
                v-if="city.file_type == 1"
                src="@/assets/doc/img/xls.png"
                alt=""
              />{{ city.pdf_name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="createSession('2')">修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
  
<script>
import $ from "jquery";
import comHeader from "@/components/ComHeader.vue";
import marked from "marked";
import store from "@/store";
// 点击图片将这个图片放到一个新建的dialog中
export default {
  components: {
    comHeader,
  },
  data() {
    return {
      returnMessageAjax: null, // 返回的数据
      message_sheight: "calc(100vh - 157px)",
      typeactive: 2, // 会话类型
      groupname: "", // 会话名称
      cities: [], // 文件列表
      checked: false, // 是否选中
      checkedCities: [], // 选中的文件
      nowcheckedCities: [], // 当前选中的文件
      dialogVisible2: false, // 编辑会话弹窗
      isuserlogin: false, // 用户是否登录
      dialogVisible: false, // 登录弹窗
      dialogVisible1: false, // 创建会话弹窗
      registeruser: {
        // 注册表单
        username: "",
        password: "",
      },
      selectedText: "", // 选中的文本
      drawer: true, // 是否显示侧边栏
      fileList: [], // 文件列表
      leftList: [], // 上传列表
      userList: [], // 会话列表
      defaultList: [], // 默认会话列表
      uesrpdflist: [], // 会话文件列表
      uesrpdfindex: null, // 会话文件索引
      indexs_file: null, // 会话文件索引
      indexsDe: null, // 默认会话索引
      pdf_id: "", // 当前会话id
      loading: false, // 是否显示加载中
      pdf_url: "", // pdf地址
      isdefualt: false, // 是否是默认会话
      list: [
        {
          ask: "",
          answer: "",
          ask_time: "",
          answer_time: "",
          stat: "",
          id: "",
          stop_show: false, // 是否显示停止按钮
          numbers: [],
          isimg: false, // 是否是图片
        },
      ],
      numbers: [],
      post: {
        // i_token: "YzPTXG6bOYiJBNrX",
        i_con: "",
        // i_cname: "清华大学图书馆",
      },
      paragraph: "", // 段落
      newMessage: "",
      start_time: 0,
      end_time: 0,
      end_: 0,
      indexs: null, // 当前会话索引
      showBlinkCursor: false, // 是否显示光标
      isshow: "right", // 是否显示侧边栏
      username: "", // 用户名
      page: 1, // 当前页
      dialogpage: 1, // 会话列表当前页
      excel_data: "", // excel数据
      nowfiletype: "", // 当前文件类型
      annex_list: [], // 附件列表
      defaultQuestion: "", // 默认问题
      questionshow: true, // 是否显示问题
      annex_text: "", // 附件文本
      leftListShow: 1, // 上传列表显示pdf/excel
      annex_img: "", // 附件图片
      setinter: null, // 定时器
      value: "ChatDocuments",
      isFetching: false, // 是否正在获取任务列表
      listType: "1", // 点解会话列表文件列表类型  1：leftList 3：defaultList
    };
  },
  created() {
    // if (localStorage.getItem("leftList")) {
    //   this.$nextTick(() => {
    //     this.leftList = JSON.parse(localStorage.getItem("leftList"));
    //     this.pdf_url = encodeURIComponent(
    //       decodeURIComponent(this.leftList[this.indexs].url).replace(/\\/g, "//")
    //     );
    //     this.pdf_id = this.leftList[this.indexs].pdf_id;
    //     //获取iframe元素
    //     var iframe = document.getElementById("iframe");
    //     //修改iframe元素的src属性值
    //     iframe.src = this.pdf_url;
    //   });
    // }
    this.initialization();
  },

  mounted() {
    console.log(this.list);
    // 默然展开行数
    this.adjustHeight();
    this.listen();
    this.dragControllerDiv();
    this.getdefaultask();
    window.setparagraph = this.setparagraph;
    window.getexcelmd = this.getexcelmd;
    window.askerror = this.askerror;
    setTimeout(() => {
      this.$nextTick(() => {
        // this.calculateHeight()
      });
    }, 100);
  },
  beforeUnmount() {
    const iframe = this.$refs.iframe;
    if (!iframe) return;
    const contentWindow = iframe.contentWindow;
    const contentDocument = contentWindow.document;
    contentDocument.removeEventListener("mouseup", this.handleMouseUp);
    this.$refs.input.removeEventListener("input", this.adjustHeight);
  },
  methods: {
    initialization() {
      if (localStorage.getItem("username")) {
        this.username = localStorage.getItem("username");
        this.isuserlogin = true;
        this.getfilelist();
        this.getuserfilelist();
      }

      this.getdefaullist();
    },
    openinput(index) {
      this.leftList[index].isedit = 2;
      this.$nextTick(() => {
        this.$refs["dbinput" + index][0].focus();
      });
    },
    // 轮询请求
    listenlist() {
      this.setinter = setTimeout(() => {
        this.$api.pdfupload
          .organ_user_pdf({
            username: this.username,
            page: this.page,
          })
          .then((res) => {
            var excelList = [];
            var pdfList = [];
            res.data.data.map((item) => {
              if (item.file_type == 1) {
                excelList.push(item);
              } else {
                pdfList.push(item);
              }
            });
            if (this.leftListShow == 1) {
              var num = 0;
              this.leftList.map((item, index) => {
                if (item.pdf_state == 0) {
                  num++;
                  excelList.map((item1) => {
                    if (item1.pdf_id == item.pdf_id) {
                      this.leftList[index].pdf_state = item1.pdf_state;
                    }
                  });
                }
              });
              if (num > 0) {
                this.listenlist();
              }
            } else {
              var num = 0;
              // 查找 leftList 中有没有 pdf_state == 0 的
              this.leftList.map((item, index) => {
                if (item.pdf_state == 0) {
                  num++;
                  pdfList.map((item1) => {
                    if (item1.pdf_id == item.pdf_id) {
                      this.leftList[index].pdf_state = item1.pdf_state;
                    }
                  });
                }
              });
              if (num > 0) {
                this.listenlist();
              }
            }
          });
      }, 5000);
    },

    askerror() {
      this.$message.error(this.$t('chatdocument.noData'));
    },
    getdefaullist() {
      // console.log('a')
      this.$api.pdfupload.default_file().then((res) => {
        if (res.data.code == 0) {
          this.defaultList = res.data.data;
        }
      });
    },
    delpdfs(e, item) {
      this.$confirm(this.$t('message.delete')).then((res) => {
        if (res == "confirm") {
          this.$api.pdfupload
            .delete_pdf({
              pdf_id: item.pdf_id,
              username: this.username,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getfilelist();
                this.getuserfilelist();
              }
            });
        }
      });
    },
    editname(e, index) {
      this.$api.pdfupload
        .pdf_name({
          pdf_id: e.pdf_id,
          pdf_name: e.pdf_name,
          username: this.username,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.leftList[index].isedit = 1;
          }
        });
      this.leftList[index].isedit = 1;
      this.getfilelist();
    },
    filetab() {
      if (this.leftListShow == 1) {
        this.leftList = this.excelList;
      } else {
        this.leftList = this.pdfList;
      }
    },
    getexcelmd(e) {
      console.log(e);
      //  文献列表typeactive == 1
      if (this.typeactive == 1) {
        console.log(this.uesrpdflist[this.indexs_file].pdf_id);
        this.uesrpdflist[this.indexs_file].pdf_id;
        this.getannex(
          e.task_id,
          this.uesrpdflist[this.indexs_file].pdf_id,
          e.jpg_path
        );
      } else {
        // 会话列表typeactive == 2
        // this.leftList[this.indexs].pdf_id;
        if (this.listType === "3") {
          // 获取defaultList的id
          this.getannex(
            e.task_id,
            this.defaultList[this.indexsDe].pdf_id,
            e.jpg_path
          );
        } else {
          // 获取leftList的id
          this.getannex(
            e.task_id,
            this.leftList[this.indexs].pdf_id,
            e.jpg_path
          );
        }
      }
    },
    getannex(e, id, img) {
      this.$api.pdfupload.annex({ pdf_id: id, task_id: e }).then((res) => {
        this.annex_text = res.data.data.text;

        if (this.annex_text == "") {
          this.$message.error(this.$t('chatdocument.unable'));
        } else {
          this.paragraph = "";
          var imageUrl = img.replace(/\\/g, "//");
          this.annex_img = imageUrl;
          setTimeout(() => {
            this.$nextTick(() => {
              this.calculateHeight();
            });
          }, 100);
        }
      });
    },
    filetabs(e) {
      console.log("e", e);
      this.typeactive = e;
      this.pdf_url = "";
    },
    // 默认问题展开，收起
    calculateHeight() {
      var message_bottom =
        document.getElementById("message_bottom").offsetHeight;
      var default_question = document.getElementById(
        "default_question_box"
      ).offsetHeight;
      if (message_bottom == 0) {
        return;
      }
      this.message_sheight =
        "calc(100vh - " + (message_bottom + default_question + 50) + "px)";
    },
    topage(e) {
      // 调用iframe的方法
      this.$refs.iframe.contentWindow.formpage(e);
    },
    // 给段落赋值
    setparagraph(ease) {
      this.copySelectedText("text", ease);
    },
    stopask() {
      this.returnMessageAjax.abort();
      this.stop_();
    },
    showquestion() {
      this.questionshow = !this.questionshow;
      this.$nextTick(() => {
        this.calculateHeight();
      });
    },
    default_question_click(item) {
      // console.log(this.returnMessageAjax)
      if (this.list[this.list.length - 1].stop_show == true) {
        return;
      }
      // this.questionshow = false
      this.newMessage = item;
      this.sendMessage();
    },
    // 获取默认问题
    getdefaultask() {
      // this.$api.pdfupload.default_question().then((res) => {
      //     if (res.data.code == 0) {
      //         this.defaultQuestion = res.data.data
      //     } else {
      //         this.$message({
      //             message: res.data.msg,
      //             type: "warning",
      //         });
      //     }
      // });
    },
    customUploadMethod() {},
    delask(id) {
      this.$api.pdfupload
        .group_delete({
          group_id: id,
          username: this.username,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: this.$t('chatdocument.delSuccess'),
              type: "success",
            });
            this.getuserfilelist();
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },

    delpdf(id, item) {
      this.uesrpdflist.splice(id, 1);
      var pdf_id_list = [];
      this.uesrpdflist.forEach((item) => {
        pdf_id_list.push(item.pdf_id);
      });
      this.$api.pdfupload
        .group_pdf({
          username: this.username,
          group_id: item.group_id,
          pdf_id_list: pdf_id_list,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: this.$t('chatdocument.delSuccess'),
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    getgroup_pdf(e, i) {
      if (this.uesrpdfindex == i) {
        this.uesrpdflist = [];
        this.uesrpdfindex = null;
        this.pdf_url = "";
        return;
      }
      this.$api.pdfupload
        .organ_user_pdf({
          username: this.username,
          page: this.dialogpage,
          group_id: e,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.uesrpdfindex = i;
            this.uesrpdflist = res.data.data;
            this.nowfiletype = this.uesrpdflist[0].file_type;
            if (this.uesrpdflist[0].file_type == 0) {
              this.$api.pdfupload
                .pdfhref({ pdf_id: this.uesrpdflist[0].pdf_id })
                .then((res) => {
                  window.pictureFrame = res.data.data.annex_list;
                  this.defaultQuestion = res.data.data.questions;

                  this.indexs_file = 0;
                  this.pdf_url = encodeURIComponent(
                    decodeURIComponent(res.data.data.pdf_url).replace(
                      /\\/g,
                      "//"
                    )
                  );
                  this.listen();
                  setTimeout(() => {
                    this.$nextTick(() => {
                      this.calculateHeight();
                    });
                  }, 100);
                });
            } else {
              this.$api.pdfupload
                .upload_excel({ pdf_id: this.uesrpdflist[0].pdf_id })
                .then((res) => {
                  this.indexs_file = 0;
                  this.excel_data = res.data.data.excel_data;
                  this.pdf_url = 1;
                });
            }
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    edit(e) {
      this.groupname = e.group_name;
      this.groupid = e.group_id;
      this.checkedCities = [];
      this.$api.pdfupload
        .organ_user_pdf({
          username: this.username,
          page: this.dialogpage,
          group_id: this.groupid,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.map((item) => {
              this.checkedCities.push(item.pdf_id);
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
      this.$api.pdfupload
        .organ_user_pdf({
          username: this.username,
          page: this.dialogpage,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.dialogVisible2 = true;
            this.cities = res.data.data;
            this.cities = this.cities.filter((item) => item.file_type == 1);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    handleCheckedCitiesChange() {
      this.nowcheckedCities = this.checkedCities;
      // const set = new Set([...this.checkedCities, ...this.nowcheckedCities]);
      // this.nowcheckedCities = [...set];
    },
    // 获取个人会话列表
    getuserfilelist() {
      this.$api.pdfupload
        .group({
          username: this.username,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.userList = res.data.data;
            this.userList.map((item) => {
              item.group_pdf = [];
            });
          }
        });
    },
    getHistory(e) {
      this.$api.pdfupload.question_history({ pdf_id: e }).then((res) => {
        if (res.data.code == 0) {
          this.list = [];
          res.data.data.map((item) => {
            this.list.push({
              ask: item.question,
              answer: item.answer,
              ask_time: "",
              answer_time: item.create_date,
              stat: 0,
              id: "",
              stop_show: false, // 是否显示停止按钮
              numbers: String(item.page) ? String(item.page).split(",") : [],
              isimg: false, // 是否是图片
            });
          });
          this.list.push({
            ask: "",
            answer: "",
            ask_time: "",
            answer_time: "",
            stat: "",
            id: "",
            stop_show: false, // 是否显示停止按钮
            numbers: [],
            isimg: false, // 是否是图片
          });
          //   console.log(this.list);
        }
      });
    },
    removeparagraph() {
      this.paragraph = "";
      this.annex_img = "";
      this.annex_text = "";
      this.$nextTick(() => {
        this.calculateHeight();
      });
    },
    createSession(e) {
      if (this.checkedCities.length == 0) {
        this.$message({
          message: this.$t('chatdocument.selFile'),
          type: "warning",
        });
        return;
      }
      if (this.groupname == "") {
        this.$message({
          message: this.$t('chatdocument.inputName'),
          type: "warning",
        });
        return;
      }
      if (e == "1") {
        this.groupid = "";
      }
      this.$api.pdfupload
        .group_create({
          username: this.username,
          name: this.groupname,
          type: e,
          group_id: this.groupid,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$api.pdfupload
              .group_pdf({
                username: this.username,
                group_id: res.data.data.group_id,
                pdf_id_list: this.checkedCities,
              })
              .then((resf) => {
                if (resf.data.code == 0) {
                  this.$message({
                    message:this.$t('chatdocument.createSuccess'),
                    type: "success",
                  });
                  this.uesrpdflist = [];
                  this.dialogVisible1 = false;
                  this.dialogVisible2 = false;
                  this.getuserfilelist();
                  this.getgroup_pdf(res.data.data.group_id, this.uesrpdfindex);
                } else {
                  this.$message({
                    message: resf.msg,
                    type: "warning",
                  });
                }
              });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    handleClose() {
      this.registershow = false;
      this.dialogVisible = false;
      this.dialogVisible1 = false;
      this.dialogVisible2 = false;
    },
    getfilelist() {
      this.excelList = [];
      this.pdfList = [];
      this.leftList = [];
      this.$api.pdfupload
        .organ_user_pdf({
          username: this.username,
          page: this.page,
        })
        .then((res) => {
          if (res.data.code == 0) {
            // this.leftList = res.data.data
            res.data.data.map((item) => {
              item.isedit = 1;

              if (item.file_type == 1) {
                console.log("excelList");
                if (this.excelList.length > 0) {
                  const exists = this.excelList.some(
                    (j) => j.pdf_id === item.pdf_id
                  );
                  if (!exists) {
                    this.excelList.push(item);
                  }
                } else {
                  this.excelList.push(item);
                }
              } else {
                console.log("pdfList");
                if (this.pdfList.length > 0) {
                  const exists = this.pdfList.some(
                    (j) => j.pdf_id === item.pdf_id
                  );
                  if (!exists) {
                    this.pdfList.push(item);
                  }
                } else {
                  this.pdfList.push(item);
                }
              }
            });
            if (this.leftListShow == 1) {
              this.leftList = this.excelList;
            } else {
              this.leftList = this.pdfList;
            }
            // 在数组中查找是否存在文件状态是0的
            var ishave = 0;

            this.leftList.find((item) => {
              console.log(item);
              if (item.pdf_state == 0) {
                ishave++;
              }
              // return item.pdf_state == 0
            });
            console.log(ishave);
            if (ishave > 0) {
              this.listenlist();
            } else {
              // 清除定时器setinter
              console.log("清除定时器setinter");
              clearTimeout(this.setinter);
            }
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },

    registerForm() {
      this.$api.pdfupload.organ_user(this.registeruser).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: this.$t('public.successful'),
            type: "success",
          });
          this.registershow = false;
          this.loginform.username = this.registeruser.username;
          this.loginform.password = this.registeruser.password;
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    createAsk() {
      if (localStorage.getItem("username")) {
        this.username = localStorage.getItem("username");
        this.isuserlogin = true;
        this.getfilelist();
        this.getuserfilelist();
      }
      if (this.isuserlogin == false) {
        this.$message.error(this.$t('public.loginTips'));
      } else {
        this.$api.pdfupload
          .organ_user_pdf({
            username: this.username,
            page: this.dialogpage,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.groupname = "";
              this.checkedCities = [];
              this.dialogVisible1 = true;
              this.cities = res.data.data;
              this.cities = this.cities.filter((item) => item.file_type == 1);
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
      }
    },
    listen() {
      this.$refs.input.addEventListener("input", this.adjustHeight);
      // 文本选中监听
      setTimeout(() => {
        const iframe = this.$refs.iframe;
        if (!iframe) return;
        const contentWindow = iframe.contentWindow;
        const contentDocument = contentWindow.document;
        contentDocument.addEventListener("mouseup", this.handleMouseUp);
      }, 5000);
    },
    tabclick(index, type) {
      this.listType = type;
      if (type == "1") {
        this.nowfiletype = this.leftList[index].file_type;
        this.isdefualt = false;
        this.indexs = index;
        if (this.leftList[index].pdf_state == 0) {
          this.$message({
            message: this.$t('chatdocument.fileTips'),
            type: "warning",
          });
          this.getfilelist();
          return;
        } else if (this.leftList[index].pdf_state == -1) {
          this.$message({
            message: this.$t('chatdocument.failFile'),
            type: "warning",
          });
          return;
        } else {
          this.annex_list = [];
          window.getannex_list = [];
          if (this.leftList[index].file_type == 0) {
            this.$api.pdfupload
              .pdfhref({ pdf_id: this.leftList[this.indexs].pdf_id })
              .then((res) => {
                this.questionshow = true;
                window.pictureFrame = res.data.data.annex_list;
                this.defaultQuestion = res.data.data.questions;

                if (res.data.data.annex_list.length > 0) {
                  this.annex_list = res.data.data.annex_list;
                  window.getannex_list = this.annex_list;
                }
                this.pdf_url = encodeURIComponent(
                  decodeURIComponent(res.data.data.pdf_url).replace(/\\/g, "//")
                );
                this.getHistory(this.leftList[this.indexs].pdf_id);
                this.listen();
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.calculateHeight();
                  });
                }, 100);
              });
          } else {
            this.$api.pdfupload
              .upload_excel({ pdf_id: this.leftList[this.indexs].pdf_id })
              .then((res) => {
                this.questionshow = true;
                this.defaultQuestion = [
                  "表格中包含了哪些字段，描述了什么数据？",
                  "请计算出每列数据的平均值？",
                  "请计算出每列数据的中位数？",
                  "每列数据中出现次数最多的数值是？",
                  "从表格的数据中我们可以得到哪些信息，通过分析我们可以得到什么结论？",
                ];
                this.excel_data = res.data.data.excel_data;
                this.getHistory(this.leftList[this.indexs].pdf_id);
                this.pdf_url = 1;
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.calculateHeight();
                  });
                }, 100);
              });
          }
        }
      } else if (type == "3") {
        this.nowfiletype = this.defaultList[index].file_type;
        this.indexsDe = index;
        this.isdefualt = true;
        if (this.defaultList[index].pdf_state == 0) {
          this.$message({
            message: this.$t('chatdocument.fileTips'),
            type: "warning",
          });
          this.getfilelist();
          return;
        } else if (this.defaultList[index].pdf_state == -1) {
          this.$message({
            message: this.$t('chatdocument.failFile'),
            type: "warning",
          });
          return;
        } else {
          this.annex_list = [];

          window.getannex_list = [];
          if (this.defaultList[index].file_type == 0) {
            this.$api.pdfupload
              .pdfhref({ pdf_id: this.defaultList[index].pdf_id })
              .then((res) => {
                this.questionshow = true;
                window.pictureFrame = res.data.data.annex_list;
                this.defaultQuestion = res.data.data.questions;
                if (res.data.data.annex_list.length > 0) {
                  this.annex_list = res.data.data.annex_list;
                  window.getannex_list = this.annex_list;
                }
                this.pdf_url = encodeURIComponent(
                  decodeURIComponent(res.data.data.pdf_url).replace(/\\/g, "//")
                );
                this.listen();
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.calculateHeight();
                  });
                }, 100);
              });
          } else {
            // excel
            this.$api.pdfupload
              .upload_excel({ pdf_id: this.defaultList[index].pdf_id })
              .then((res) => {
                this.questionshow = true;
                this.excel_data = res.data.data.excel_data;
                this.defaultQuestion = [
                  "表格中包含了哪些字段，描述了什么数据？",
                  "请计算出每列数据的平均值？",
                  "请计算出每列数据的中位数？",
                  "每列数据中出现次数最多的数值是？",
                  "从表格的数据中我们可以得到哪些信息，通过分析我们可以得到什么结论？",
                ];
                this.pdf_url = 1;
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.calculateHeight();
                  });
                }, 100);
              });
          }
        }
      } else {
        this.nowfiletype = this.uesrpdflist[index].file_type;
        this.indexs_file = index;
        if (this.uesrpdflist[index].pdf_state == 0) {
          this.$message({
            message: this.$t('chatdocument.fileTips'),
            type: "warning",
          });
          this.getfilelist();
          return;
        } else if (this.uesrpdflist[index].pdf_state == -1) {
          this.$message({
            message: this.$t('chatdocument.failFile'),
            type: "warning",
          });
          return;
        } else {
          this.annex_list = [];
          window.getannex_list = [];
          if (this.uesrpdflist[index].file_type == 0) {
            this.$api.pdfupload
              .pdfhref({ pdf_id: this.uesrpdflist[index].pdf_id })
              .then((res) => {
                window.pictureFrame = res.data.data.annex_list;
                this.questionshow = true;
                this.defaultQuestion = res.data.data.questions;
                if (res.data.data.annex_list.length > 0) {
                  this.annex_list = res.data.data.annex_list;
                  window.getannex_list = this.annex_list;
                }
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.calculateHeight();
                  });
                }, 100);

                this.getHistory(this.uesrpdflist[index].pdf_id);
                this.pdf_url = encodeURIComponent(
                  decodeURIComponent(res.data.data.pdf_url).replace(/\\/g, "//")
                );
                this.listen();
              });
          } else {
            this.$api.pdfupload
              .upload_excel({ pdf_id: this.uesrpdflist[index].pdf_id })
              .then((res) => {
                this.questionshow = true;
                this.defaultQuestion = [
                  "表格中包含了哪些字段，描述了什么数据？",
                  "请计算出每列数据的平均值？",
                  "请计算出每列数据的中位数？",
                  "每列数据中出现次数最多的数值是？",
                  "从表格的数据中我们可以得到哪些信息，通过分析我们可以得到什么结论？",
                ];
                this.getHistory(this.uesrpdflist[index].pdf_id);
                this.excel_data = res.data.data.excel_data;
                this.pdf_url = 1;
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.calculateHeight();
                  });
                }, 100);
              });
          }
        }
      }
      this.list = [
        {
          ask: "",
          answer: "",
          ask_time: "",
          answer_time: "",
          stat: "",
          id: "",
          stop_show: false, // 是否显示停止按钮
          numbers: [],
          isimg: false,
        },
      ];
      this.calculateHeight();
    },
    adjustHeight() {
      const input = this.$refs.input;
      const scrollHeight = input.scrollHeight;
      const lineHeight = 25;
      if (scrollHeight > lineHeight * 5) {
        input.style.height = `${lineHeight * 5}px`;
        input.style.overflowY = "auto";
      } else {
        input.style.height = `${scrollHeight}px`;
        input.style.overflowY = "hidden";
      }

      this.calculateHeight();
    },
    handleMouseUp(event) {
      const selection = window.frames[0].getSelection().toString();
      if (selection) {
        this.selectedText = selection;
        const rect = event.target.getBoundingClientRect();
        // 获取网页视口宽度
        // 获取id为center_left的宽度
        let clientWidth = document.getElementById("center_left").offsetWidth;
        let x = event.clientX + clientWidth;
        let y = event.clientY + 30;
        this.$refs.button.style.left = `${x}px`;
        this.$refs.button.style.top = `${y}px`;
        // iframe.contentDocument.body.appendChild(button);
      }
    },
    copySelectedText(e, text) {
      if (e == "text") {
        this.paragraph = text;
      } else {
        this.selectedText = window.frames[0].getSelection().toString();
        var selectedText = window.frames[0].getSelection().toString();
        this.paragraph = selectedText;
      }
      this.annex_img = "";
      this.annex_text = "";
      this.selectedText = "";

      // 聚焦输入框
      this.$refs.input.focus();
      setTimeout(() => {
        this.adjustHeight();
      }, 100);
    },
    tohome() {
      this.$router.push({ path: "/" });
    },
    hidelist() {
      //juqery 判断如果有宽度收起 无宽度展开 .center_left 同时.box1 补充宽度
      // 获取.mid 的宽度
      var mid_width = $(".mid").width();
      var width = mid_width + "px";
      if ($(".center_left").width() == 0) {
        $(".center_left").animate({ width: "280px" }, 500);
        $(".center_left").attr("style", "padding:10px;");
        // 获取视口宽度
        var width = $(window).width() - 280 + "px";
        $(".box1").animate({ width: width }, 500);
        $(".mid").attr("style", "");
        $(".left").attr("style", "");
        $(".left").animate({ width: "calc(100% - " + width + ")" }, 500);
        this.isshow = "right";
      } else {
        $(".center_left").animate({ width: "0px" }, 500);
        $(".center_left").attr("style", "padding:0;");
        $(".box1").animate({ width: "100%" }, 500);
        $(".mid").attr("style", "");
        $(".left").attr("style", "");
        $(".left").animate({ width: "calc(100% - " + width + ")" }, 500);
        this.isshow = "left";
      }
      // $(".center_left").animate({ width: "0px" }, 500);sk_duan
      // js设置 .mid 的style 属性为空
    },
    sendMessage() {
      console.log(this.message_sheight);
      if (!this.newMessage) {
        return;
      }
      var default_question = document.getElementById(
        "default_question_box"
      ).offsetHeight;
      this.message_sheight = "calc(100vh - " + (default_question + 122) + "px)";
      var newMessage = this.newMessage;
      var paragraph = "";
      if (this.paragraph) {
        paragraph = this.paragraph;
      }
      if (this.annex_text) {
        paragraph = this.annex_text;
      }
      if (this.annex_text) {
        this.list[this.list.length - 1].ask_duan = this.annex_img;
        this.list[this.list.length - 1].isimg = true;
      } else {
        this.list[this.list.length - 1].ask_duan = this.paragraph;
        this.list[this.list.length - 1].isimg = false;
      }
      console.log(this.list);
      this.list[this.list.length - 1].ask = this.newMessage;
      this.list[this.list.length - 1].ask_time = this.currentTime();
      // this.list[this.list.length - 1].answer =
      //   "处理中，请稍后" + `<i class="el-icon-loading"></i>`;
      // this.list[this.list.length - 1].answer =
      //   "正在给您总结答案，请稍后...";
      this.list[this.list.length - 1].answer = " ";
      this.show_ = false;
      this.limit = false;
      // this.postQuestions(this.post);
      this.showBlinkCursor = true;
      if (window.document.getElementById("div")) {
        this.scrollBottm();
      }
      let that = this;
      that.start_time = 0;
      that.end_time = 0;
      that.end_ = 0;
      this.newMessage = "";
      this.paragraph = "";
      this.annex_text = "";
      this.annex_img = "";
      var pdf_id_list = [];
      if (this.typeactive == 2) {
        if (this.isdefualt) {
          pdf_id_list.push(this.defaultList[this.indexsDe].pdf_id);
        } else {
          pdf_id_list.push(this.leftList[this.indexs].pdf_id);
        }
      } else {
        if (this.checked) {
          pdf_id_list.push(this.uesrpdflist[this.indexs_file].pdf_id);
        } else {
          this.uesrpdflist.forEach((item) => {
            pdf_id_list.push(item.pdf_id);
          });
        }
      }
      this.list[this.list.length - 1].stop_show = true;
      this.returnMessageAjax = $.ajax({
        // url: window.location.origin + "/api/pdf/question/",
        url: this.$root.baseURL + "/api/pdf/question/",
        //   url:"http://192.168.100.198:81/api/pdf/question/",
        // url: "http://192.168.66.9:7000/api/pdf/question/",
        // url: 'https://chatlibrary.newacademic.net/api/pdf/default_question/',
        timeout: 50000, // 请求超时时间
        type: "POST",
        dataType: "json",
        data: JSON.stringify({
          question: newMessage,
          pdf_id_list: pdf_id_list,
          paragraph: paragraph,
        }),
        xhrFields: {
          onprogress: function (e) {
            // console.log(e);
            let response = e.currentTarget.response;
            try {
              if (response.includes('"code":') && response.includes('"msg":')) {
                that.quit();
                that.$message.error(JSON.parse(response).msg);
              }
              if (response.includes("[stop:0]")) {
                let txt_arr = response.split("[stop:0]");
                response = txt_arr[0] + txt_arr[1];
              }
              if (response.includes("[stop:1]")) {
                let txt_arr = response.split("[stop:1]");
                response = txt_arr[0] + txt_arr[1];
              }
            } catch (error) {
              console.log(error);
            }
            that.splicing_(response);
            that.time_(that.start_time, "start");
            that.scrollBottm("div");

            // returnMessageAjax.abort();
          },
          onload: function (e) {},
        },
        timeout: 1000 * 60 * 2,
        headers: {
          "Content-Type": "application/json",
          token: store.getCookie("Chat_token"),
          // "Cache-Control": "no-cache", //重点清除接口的缓存
        },
        complete: function (XMLHttpRequest, status) {
          console.log(XMLHttpRequest);
          // return
          var responseText = XMLHttpRequest.getResponseHeader("Content-Type");
          if (responseText) {
            var numbers = responseText.split("page:")[1];
          }
          // 删除numbers中的\r\n
          if (numbers) {
            if (numbers.indexOf("\r\n") != -1) {
              numbers = numbers.replace(/[\r\n]/g, "");
            }

            numbers = numbers.split(",");
          }

          if (status === "timeout") {
            alert("请求超时");
          } else if (status === "parsererror") {
            that.time_(that.end_time, "end");
            that.stop_(numbers);
          }
        },
      });
    },
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "/" +
        dateArr[0] +
        "/" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收，也可直接返回  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      return strDate;
    },
    stop_(e) {
      let add = {
        ask: "",
        answer: "",
        ask_time: "",
        answer_time: "",
        stat: "",
        id: "",
      };
      this.list.push(add);
      this.list[this.list.length - 2].stat = 0;
      this.list[this.list.length - 2].answer_time = this.currentTime();
      this.list[this.list.length - 2].numbers = e;
      this.limit = true;
      // this.numbers = []
      this.scrollBottm();
      this.list[this.list.length - 2].stop_show = false;
      this.showBlinkCursor = false;
    },
    time_(time, type) {
      if (time == 0) {
        if (type == "start") {
          this.start_time = this.currentTime();
        } else {
          this.end_time = this.currentTime();
        }
      }
    },
    isScrollbarAtBottom() {
      const element = window.document.getElementById("div");
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;
      var scrollTop = element.scrollTop;
      return scrollTop === scrollHeight - clientHeight;
    },
    // 滚动条到底部
    scrollBottm(e) {
      // 如果id为div的元素滚动条位于底部

      // msg-box 是你要滚动的div的id
      var that = this;
      if (e) {
        if (that.isScrollbarAtBottom()) {
          setTimeout(function () {
            const el = window.document.getElementById("div");
            if (el.scrollHeight) {
              el.scrollTop = el.scrollHeight + 100;
            }
          }, 50);
        }
      } else {
        setTimeout(function () {
          const el = window.document.getElementById("div");
          if (el.scrollHeight) {
            el.scrollTop = el.scrollHeight + 100;
          }
        }, 50);
      }
    },
    splicing_(txt) {
      if (txt) {
        this.list[this.list.length - 1].answer += txt;
        this.list[this.list.length - 1].answer = txt;
        if (txt.includes("[") && this.leftListShow == 0) {
          let txt_copy = txt;
          let txt_arr = txt_copy.split("[");
          txt_arr[txt_arr.length - 1] = txt_arr[txt_arr.length - 1].slice(
            0,
            txt_arr[txt_arr.length - 1].length - 1
          );
          // return
          this.list[this.list.length - 1].id = txt_arr[txt_arr.length - 1];
          if (txt_arr.length > 0) {
            let splicing_ = "";
            txt_arr.forEach((item, index) => {
              if (index < txt_arr.length - 1) {
                splicing_ =
                  txt_arr.length > 2 && index < txt_arr.length - 2
                    ? splicing_ + item + "["
                    : splicing_ + item;
              }
            });
            splicing_ = marked(splicing_);
            console.log(splicing_);
            this.list[this.list.length - 1].answer = splicing_;
          }
        } else {
          txt = marked(txt);
          // 给txt中的a标签添加style 颜色蓝色 带下划线 设置打开新页面
          txt = txt.replace(
            /<a/g,
            '<a style="color:#409EFF;text-decoration:underline;" target="_blank"'
          );
          // 给txt中的img标签添加style 宽度100% 并增加点击放大事件
          txt = txt.replace(
            /<img/g,
            '<img style="width:100%;cursor:zoom-in;" onclick="imgclick(this)"'
          );
          // console.log(txt);
          this.list[this.list.length - 1].answer = txt;
        }
      }
    },
    beforeUpload(file) {
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(fileName);
      return;
    },
    handlePreview(file, fileList) {
      console.log(file, JSON.stringify(fileList));
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      // console.log(fileType);
      const isLt20M = file.size / 1024 / 1024 < 20;
      // console.log(file, isLt20M);
      if (fileType == "xls" || fileType == "xlsx") {
        if (this.isuserlogin == false) {
          this.$message.error(this.$t('public.loginTips'));
          this.dialogVisible = true;
        } else {
          if (!isLt20M) {
            this.$message.error(this.$t('message.size'));
            return false;
          } else {
            var file = file.raw;
            // this.fileList = fileList
            // this.fileList.push(file.raw);
            this.filename = file.name;
            var form = new FormData();
            form.append("file", file);
            form.append("username", this.username);
            this.loading = true;
            this.$api.pdfupload.pdfupload(form).then((res) => {
              this.loading = false;
              console.log(res);
              if (res.data.code == 0) {
                this.$message.success(this.$t('chatdocument.uploadSuccess'));
                this.getfilelist();
              }
              // 上传完成重置上传
              this.$refs.upload.clearFiles();
            });
          }
        }
      }
      const isInvalidFile = fileList.some((file) => {
        const fileName = file.name;
        const invalidFileRegex = /\.(?!pdf$)/i; // 匹配除了pdf之外的文件后缀
        return invalidFileRegex.test(fileName);
      });

      // if (isInvalidFile && file.name == fileList[fileList.length - 1].name) {
      //   this.$message({
      //     message: "上传文件仅支持 pdf 格式!",
      //     type: "warning",
      //   });
      // }
    },
    dragControllerDiv() {
      var resize = document.getElementsByClassName("resize");
      var left = document.getElementsByClassName("left");
      var mid = document.getElementsByClassName("mid");
      var box = document.getElementsByClassName("box1");
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          document.getElementsByClassName("mengcen")[0].style.display = "block";
          //颜色改变提醒
          resize[i].style.background = "#818181";
          var startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            document.getElementsByClassName("mengcen")[0].style.display =
              "block";
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

            if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
            if (moveLen > maxT - 80) moveLen = maxT - 80; //右边区域最小宽度为150px

            resize[i].style.left = moveLen; // 设置左侧区域的宽度

            for (let j = 0; j < left.length; j++) {
              if ($(".center_left").width() == 0) {
                left[j].style.width = moveLen + "px";
                mid[j].style.width = box[i].clientWidth - moveLen - 10 + "px";
              } else {
                left[j].style.width = moveLen - 280 + "px";
                mid[j].style.width =
                  box[i].clientWidth - moveLen - 10 + 285 + "px";
              }
            }
          };
          // 鼠标松开事件
          document.onmouseup = function () {
            //颜色恢复
            document.getElementsByClassName("mengcen")[0].style.display =
              "none";
            resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    },
  },
  computed: {
    markdownToHtml() {
      var str = marked(this.excel_data);
      // 给str中的table标签添加class
      str = str.replace(/<table/g, '<table class="table-bordered"');
      // 给str中的th tr标签添加class
      str = str.replace(/<th/g, '<th class="text-center gongong"');
      str = str.replace(/<td/g, '<td class="gongong"');
      str = str.replace(/<tr/g, '<tr class="text-tr"');
      return str;
    },
  },
};
</script>
  
<style lang="less" scoped>
.uploaddiv:hover {
  border: 1px dashed rgb(255, 255, 255);
}
.uploaddiv {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  //   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px dashed rgb(97, 97, 97);
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  svg {
    width: 20px;
  }

  p {
    font-size: 14px;
    color: #3e3f42;

    span {
      font-size: 12px;
      color: #9ea0a5;
    }
  }
}

.center {
  min-height: calc(100vh - 50px);
  background: #fff;
  display: flex;

  .center_left {
    box-sizing: content-box;
    width: 280px;
    height: calc(100vh - 70px);
    padding: 10px;
    position: relative;
    overflow: auto;
    border-right: 1px solid rgb(184, 184, 184);

    .center_left_topbtn {
      margin-bottom: 10px;
    }

    .create_ask {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      background: #f2f2f2;
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;
      overflow: hidden;

      div {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .typeactive {
        // background: #e6a23c;
        background: #9cbb6b;
        color: #f2f2f2;
        height: 100%;
      }
    }

    .center_left_top {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 25px 0;
      cursor: pointer;

      .center_left_top_title {
        font-size: 22px;
        font-weight: 600;
      }

      .center_left_top_titles {
        font-size: 14px;
        color: #3e3f42;
      }

      img {
        position: absolute;
        top: 25px;
        right: 70px;
      }
    }

    // background: blue;
    .center_left_fixed {
      z-index: 999;
      position: absolute;
      right: -25px;
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
      background: #fff;
      border-top: 1px solid #9ea0a5;
      border-bottom: 1px solid #9ea0a5;
      border-right: 1px solid #9ea0a5;
      top: 50%;
      width: 35px;
      height: 35px;
      padding-left: 5px;
      display: flex;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }

    .asklist {
      li {
        .asklist_ask {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          cursor: pointer;
          border-radius: 5px;
          padding: 10px 5px 10px 20px;
          background: #f5f5f5;
        }

        // .asklist_ask:hover .el-icon-delete-solid{
        //   display: block;
        // }
        // .el-icon-delete-solid{
        //   display: none;
        // }
        .asklist_askactive {
          background: #e7e7e7;
        }

        div {
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 20px;
          }

          i {
            font-size: 20px;
            margin: 0 10px;
          }
        }
      }
    }

    .filelist {
      //   max-height: calc(100vh - 344px);
      height: calc(100vh - 350px);
      overflow: auto;

      .active {
        background: #e7e7e7;
      }

      li {
        background: #f5f5f5;
        margin-bottom: 10px;
        cursor: pointer;
        border-radius: 5px;
        padding: 10px 5px;

        div {
          display: flex;
        }

        .litop {
          align-items: center;

          img {
            width: 25px;
            height: 25px;
            margin-left: 10px;
          }

          p {
            margin-left: 10px;
            text-align: left !important;
            font-size: 14px;
            color: #3e3f42;
            display: inline-block;
            white-space: nowrap;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .el-icon-error {
            width: 20px;
            height: 20px;
          }
        }

        .libottom {
          justify-content: space-between;

          div {
            align-items: center;
            font-size: 12px;
            color: #9ea0a5;

            i {
              font-size: 14px;
              margin-right: 5px;
            }

            .el-icon-check {
              color: #16d46b;
              font-size: 24px;
            }

            .el-icon-close {
              font-size: 24px;
            }

            .el-icon-loading {
              font-size: 24px;
            }
          }
        }
      }

      li:hover .el-icon-error {
        display: block;
      }

      .el-icon-error {
        display: none;
      }
    }
  }
}

.default_question {
  width: 95%;
  margin: auto;
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
}

.default_question_item {
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f4f4f4;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: left;
  line-height: 20px;
}

.default_question_item:hover {
  background-color: #e0e0e0;
}

.default_question_item span {
  color: #333;
}

.table {
  width: 100%;
  max-height: calc(100vh - 50px);
  overflow: auto;
}

.box1 {
  width: calc(100% - 280px);
  min-height: 100%;
  overflow: hidden;
  display: flex;
  background: linear-gradient(
    179.99999999999994deg,
    rgba(212, 225, 251, 1) 0%,
    rgba(236, 223, 232, 1) 15%,
    rgba(255, 255, 255, 1) 31%
  );

  /deep/ .el-upload-dragger {
    width: 100%;
    height: 150px;
  }

  .box_center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    h1 {
      text-align: center;
      font-size: 46px;
    }

    .tagdiv {
      margin: auto;
      margin-top: 50px;
      margin-bottom: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      .tagdiv_left {
        border-right: 2px solid #999;
        padding: 25px 45px 25px 0;
        position: relative;

        img {
          width: 40px;
          height: auto;
          top: 10px;
          right: 10px;
          position: absolute;
        }
      }

      .tagdiv_right {
        padding: 25px 0px 25px 45px;
        text-align: left;

        h2 {
          font-size: 22px;
          margin: 10px 0;
          font-weight: 700 !important;
        }

        p {
          font-size: 16px;
          margin: 5px 0;
          line-height: 20px;
        }
      }

      div {
        box-sizing: border-box;
        font-size: 20px;
        font-weight: bold;
        font-size: 14px;
        padding: 5px 10px;
        margin: 5px;
        font-weight: 500;
        color: #333;
      }
    }
  }
}

.left {
  position: relative;
  width: calc(100% - 450px);
  /*左侧初始化宽度*/
  background: #ffffff;
}

.mengcen {
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  display: none;
}

.resize {
  cursor: col-resize;
  position: relative;
  /* top: 45%; */
  background-color: #d6d6d6;
  border-radius: 5px;
  /* margin-top: 10px; */
  width: 5px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  /* color: white; */
}

.resize:hover {
  color: #444444;
}

.mid {
  width: 450px;
  height: calc(100vh - 50px);
  /*右侧初始化宽度*/
  background: #fff;
  position: relative;

  /* box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11); */
  // position: relative;
  .mid_top {
    width: 100%;
    height: 36px;
    background: #fff;
    border-bottom: 1px solid #c7c7c7;
    display: flex;
    padding: 0 10px;
    align-items: center;
    font-weight: 600;

    img {
      width: 25px;
    }
  }
  .top_fun_list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px;
    // border-bottom: 1px solid #e0e0e0;
    img {
      vertical-align: sub;
    }
  }
}

.chat-input {
  // position: absolute;
  width: 95%;
  // bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 5px;
    display: flex;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
}

.other {
  box-sizing: border-box;
  margin-bottom: 10px;
  flex-grow: 1;
  padding: 11px;
  border: none;
  border-radius: 4px;
  outline: none;
  resize: none;
  line-height: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  font-family: none;
}

.other:hover i {
  position: absolute;
  top: 0;
  left: 50%;
}

.chat-input img {
  width: 25px;
  margin-right: 10px;
  cursor: pointer;
}

.chat-input input[type="text"] {
  flex-grow: 1;
  padding: 8px;
  border: none;
  background: transparent;
  border-radius: 4px;
  outline: none;
}

.chat-input button {
  margin-left: 10px;
  padding: 8px 16px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.chat-input button:hover {
  background-color: #555;
}

.message_s::-webkit-scrollbar {
  display: none;
}

.message_s {
  // padding: 20px;
  // height: ;
  overflow-x: scroll;
  overflow-y: scroll;

  .ask_css {
    width: 100%;
    // padding: 20px 20%;
    padding: 20px;
    font-size: 14px;
    border-bottom: 1px solid #c7c7c7;
    display: flex;

    .ask_img {
      width: 25px;
      height: 25px;
      margin-right: 20px;
    }
  }

  .time__ask {
    font-size: 12px;
    color: #9ea0a5;
  }

  .answer_css {
    width: 100%;
    // margin: auto;
    // padding: 20px 20% 5px 20%;
    // margin: 10px 0;
    // display: flex;
    padding: 10px 20px;
    background: rgb(245, 245, 245);
    border-bottom: 1px solid #c7c7c7;
    display: flex;

    .ask_img {
      width: 25px;
      height: 25px;
      margin-right: 20px;
    }

    // background: #f2f2f2;
    .answer_css_ {
      line-height: 1.5;
      font-size: 14px;
    }

    .time__answer {
      font-size: 12px;
      color: #9ea0a5;
    }

    .pointer_s {
      display: flex;
      position: absolute;
      bottom: -18px;
      right: 0px;

      img {
        width: 20px;
        margin: 0 3px;
        cursor: pointer;
      }

      span {
        margin: 0 4px;
        text-decoration: underline;
        cursor: pointer;
        line-height: initial;
      }
    }

    .pointer_s_ {
      display: flex;
      position: absolute;
      bottom: -18px;
      left: 130px;

      img {
        width: 20px;
        margin: 0 3px;
        cursor: pointer;
      }

      span {
        margin: 0 4px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}

.excel {
  width: 95%;
  max-height: 200px;
  overflow: auto;
  margin-bottom: 10px;
  flex-grow: 1;
  padding: 11px;
  border: none;
  border-radius: 4px;
  outline: none;
  resize: none;
  line-height: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  font-family: none;
}

.font_duan {
  display: inline-block;
  background: whitesmoke;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 12px;
  max-height: 200px;
  overflow: auto;
}

.message_bottom {
  background: #f2f2f2;
  min-height: 70px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 10px;

  .paragraphRe {
    width: 95%;
    margin: 5px auto;
    display: flex;
    justify-content: flex-end;

    i {
      cursor: pointer;
      font-size: 18px;
    }
  }
}

.stopask {
  background: #e6a23c;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 5px;
  width: 126px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  margin: 10px auto;
  cursor: pointer;
}

.tooltip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border: 0px solid transparent;
  background-color: none;
  border-radius: 1.25em;
  transition: all 0.2s linear;
  cursor: pointer;
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 4em;
  background-color: rgba(0, 0, 0, 0.253);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 25%;
  left: 110%;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent rgba(0, 0, 0, 0.253) transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

// 盒子下的小标签切换样式
.filetab {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 20px 5px;
}
/deep/ .el-collapse-item__content {
  padding: 8px 10px;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  border: #e6a23c;
  background: #e6a23c;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #e6a23c;
}

/deep/ .el-radio__inner:hover {
  border-color: #e6a23c;
}

/deep/ .el-button--primary {
  border-color: #e6a23c;
  background-color: #e6a23c;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #e6a23c;
  background-color: #e6a23c;
}

/deep/ .el-checkbox-group {
  text-align: left;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #e6a23c;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #e6a23c;
}

/deep/ .el-dialog__headerbtn:hover .el-dialog__close {
  color: #e6a23c;
}

/deep/ .el-upload-dragger:hover {
  border-color: #e6a23c;
}
/deep/ .el-upload {
  width: 100%;
}

/deep/ .el-upload-dragger {
  width: 100%;
  height: 80px;
}
.create_ask_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;
  color: #e6a23c;
  border: 1px solid #e6a23c;
}
.create_ask_btn_no {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;

  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;
  cursor: not-allowed;
  border: 1px solid #dcdfe6;
  color: #bcbec2;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
}
</style>
<style scoped>
.v-enter-active {
  animation: testanimation 1s;
}

.v-leave-active {
  animation: testanimation 1s reverse;
}

@keyframes testanimation {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(0px);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.blinkCursor {
  animation: Blink 1s ease-in 0s infinite;
}

@keyframes Blink {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/* 隐藏垂直滚动条 */
::-webkit-scrollbar {
  width: 0.5em;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 20px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
</style>